module.exports = __webpack_public_path__ + "img/f4_img.7d27516.png";